/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../../common";
import type {
  HERC4610Logic,
  HERC4610LogicInterface,
} from "../../../../contracts/dependant/erc4610/HERC4610Logic";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "caller",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "delegator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "SetDelegator",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "baseURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "delegatorOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "reserved",
        type: "bool",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "delegator",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "setDelegator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenOfOwnerByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type HERC4610LogicConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: HERC4610LogicConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class HERC4610Logic__factory extends ContractFactory {
  constructor(...args: HERC4610LogicConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<HERC4610Logic> {
    return super.deploy(overrides || {}) as Promise<HERC4610Logic>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): HERC4610Logic {
    return super.attach(address) as HERC4610Logic;
  }
  override connect(signer: Signer): HERC4610Logic__factory {
    return super.connect(signer) as HERC4610Logic__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): HERC4610LogicInterface {
    return new utils.Interface(_abi) as HERC4610LogicInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): HERC4610Logic {
    return new Contract(address, _abi, signerOrProvider) as HERC4610Logic;
  }
}
